<template>
    <div class="mt-card-item">
        <div class="mt-card-avatar mt-overlay-1">
            <img :src="img">
        </div>
        <div class="mt-card-content">
            <h3 class="mt-card-name" v-html="title"></h3>
            <div class="mt-card-desc font-grey-mint" v-html="$options.filters.md(description)"></div>
            <div class="mt-card-footer">
                <button class="btn btn-block btn-outline"
                        v-if="nbClaims"
                        :class="btnClass">{{ nbClaims }} CLAIMS</button>
            </div>
        </div>
    </div>
</template>
<script>
  /* ============
   * DealCard Component
   * ============
   *
   */

  export default {
    props: {
      dealId: {
        type: Number,
        required: true
      },
      img: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      nbClaims: {
        type: Number,
        default: null
      },
      dealData: {
        type: Object,
        required: true
      }
    },
    computed: {
      btnClass () {
        let btnClass = 'blue'

        return [btnClass]
      }
    }
  }
</script>

<style lang="scss" scoped>
    .mt-card-desc {
        padding: 0 5px;
    }

    .mt-card-footer {
        padding: 5px 8px 12px;

        .btn.btn-outline {
            &:hover, &:active, &:active:hover, &:active:focus, &:focus, &.active {
                border-color: #32c5d2;
                color: #32c5d2;
                background-color: #fff;
            }
        }
    }

    .mt-element-overlay .mt-overlay-1:hover img {
      transform: none;
    }
</style>



// WEBPACK FOOTER //
// src/app/components/deal/DealCard.vue